export const CREATE_USDC_VAULT = `
  // Flow Wallet - testnet Script  enableTokenStorage - v2.76
// Extension-2.9.5

import FungibleToken from 0x9a0766d93b6608b7

import USDCFlow from 0x64adf39cbc354fcb

transaction {

    prepare(signer: auth(Storage, Capabilities) &Account) {

        if signer.storage.borrow<&USDCFlow.Vault>(from: /storage/usdcFlowVault ) == nil {
            signer.storage.save(<- USDCFlow.createEmptyVault(vaultType: Type<@USDCFlow.Vault>()), to: /storage/usdcFlowVault)
        }

        if signer.capabilities.exists(/public/usdcFlowReceiver) == false {
            let receiverCapability = signer.capabilities.storage.issue<&USDCFlow.Vault>(/storage/usdcFlowVault)
            signer.capabilities.publish(receiverCapability, at: /public/usdcFlowReceiver)
        
        }
       
        if signer.capabilities.exists(/public/usdcFlowMetadata) == false {
            let balanceCapability = signer.capabilities.storage.issue<&USDCFlow.Vault>(/storage/usdcFlowVault)
            signer.capabilities.publish(balanceCapability, at: /public/usdcFlowMetadata)
        }
    
    }
}
`
